export default __webpack_public_path__ + "static/media/bdswissSCReal02_downloadMT4.204f7bcf.png";